import { defineMessages } from 'react-intl';

/**
 * Messages for ContentsPropertiesModal batch operations
 * Used in: Contents folder view batch properties modal
 *
 * @category Contents Management
 * @since 1.0.0
 */
export const contentsPropertiesModalMessages = defineMessages({
  // Modal title
  properties: {
    id: 'Properties',
    defaultMessage: 'Properties',
  },

  // Fieldset titles
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  batchProcessing: {
    id: 'Batch processing',
    defaultMessage: 'Batch processing',
  },

  // Standard fields
  effectiveTitle: {
    id: 'Publishing Date',
    defaultMessage: 'Publishing Date',
  },
  effectiveDescription: {
    id: 'If this date is in the future, the content will not show up in listings and searches until this date.',
    defaultMessage:
      'If this date is in the future, the content will not show up in listings and searches until this date.',
  },
  expiresTitle: {
    id: 'Expiration Date',
    defaultMessage: 'Expiration Date',
  },
  expiresDescription: {
    id: 'When this date is reached, the content will nolonger be visible in listings and searches.',
    defaultMessage:
      'When this date is reached, the content will nolonger be visible in listings and searches.',
  },
  rightsTitle: {
    id: 'Rights',
    defaultMessage: 'Rights',
  },
  rightsDescription: {
    id: 'Copyright statement or other rights information on this item.',
    defaultMessage:
      'Copyright statement or other rights information on this item.',
  },
  creatorsTitle: {
    id: 'Creators',
    defaultMessage: 'Creators',
  },
  creatorsDescription: {
    id: 'Persons responsible for creating the content of this item. Please enter a list of user names, one per line. The principal creator should come first.',
    defaultMessage:
      'Persons responsible for creating the content of this item. Please enter a list of user names, one per line. The principal creator should come first.',
  },
  excludeFromNavTitle: {
    id: 'Exclude from navigation',
    defaultMessage: 'Exclude from navigation',
  },
  excludeFromNavDescription: {
    id: 'If selected, this item will not appear in the navigation tree',
    defaultMessage:
      'If selected, this item will not appear in the navigation tree',
  },
  link: {
    id: 'contents.properties.link',
    defaultMessage: 'Link',
  },

  // Error messages
  batchUpdateError: {
    id: 'contents.properties.batchUpdateError',
    defaultMessage: 'Batch update failed',
  },
  batchUpdateErrorContent: {
    id: 'contents.properties.batchUpdateErrorContent',
    defaultMessage:
      'An error occurred while updating the selected items. Please try again.',
  },

  // Universities
  universitiesToAdd: {
    id: 'contents.properties.universitiesToAdd',
    defaultMessage: 'Universities to add',
  },
  universitiesToAddDescription: {
    id: 'contents.properties.universitiesToAddDescription',
    defaultMessage: 'Select universities to add to all selected items',
  },
  universitiesToRemove: {
    id: 'contents.properties.universitiesToRemove',
    defaultMessage: 'Universities to remove',
  },
  universitiesToRemoveDescription: {
    id: 'contents.properties.universitiesToRemoveDescription',
    defaultMessage: 'Select from currently assigned universities',
  },

  // Organisation entities
  organisationEntitiesToAdd: {
    id: 'contents.properties.organisationEntitiesToAdd',
    defaultMessage: 'Organisation entities to add',
  },
  organisationEntitiesToAddDescription: {
    id: 'contents.properties.organisationEntitiesToAddDescription',
    defaultMessage: 'Select organisation entities to add to all selected items',
  },
  organisationEntitiesToRemove: {
    id: 'contents.properties.organisationEntitiesToRemove',
    defaultMessage: 'Organisation entities to remove',
  },
  organisationEntitiesToRemoveDescription: {
    id: 'contents.properties.organisationEntitiesToRemoveDescription',
    defaultMessage: 'Select from currently assigned organisation entities',
  },

  // Topics
  topicsToAdd: {
    id: 'contents.properties.topicsToAdd',
    defaultMessage: 'Topics to add',
  },
  topicsToAddDescription: {
    id: 'contents.properties.topicsToAddDescription',
    defaultMessage: 'Select topics to add to all selected items',
  },
  topicsToRemove: {
    id: 'contents.properties.topicsToRemove',
    defaultMessage: 'Topics to remove',
  },
  topicsToRemoveDescription: {
    id: 'contents.properties.topicsToRemoveDescription',
    defaultMessage: 'Select from currently assigned topics',
  },

  // Research areas
  researchAreasToAdd: {
    id: 'contents.properties.researchAreasToAdd',
    defaultMessage: 'Research areas to add',
  },
  researchAreasToAddDescription: {
    id: 'contents.properties.researchAreasToAddDescription',
    defaultMessage: 'Select research areas to add to all selected items',
  },
  researchAreasToRemove: {
    id: 'contents.properties.researchAreasToRemove',
    defaultMessage: 'Research areas to remove',
  },
  researchAreasToRemoveDescription: {
    id: 'contents.properties.researchAreasToRemoveDescription',
    defaultMessage: 'Select from currently assigned research areas',
  },

  // Future fields (Zukunftsfelder)
  futureFieldsToAdd: {
    id: 'contents.properties.futureFieldsToAdd',
    defaultMessage: 'Future fields to add',
  },
  futureFieldsToAddDescription: {
    id: 'contents.properties.futureFieldsToAddDescription',
    defaultMessage: 'Select future fields to add to all selected items',
  },
  futureFieldsToRemove: {
    id: 'contents.properties.futureFieldsToRemove',
    defaultMessage: 'Future fields to remove',
  },
  futureFieldsToRemoveDescription: {
    id: 'contents.properties.futureFieldsToRemoveDescription',
    defaultMessage: 'Select from currently assigned future fields',
  },
});
